const hoverActiveByViewKey: Record<string, boolean> = {}

export function setChartHoverActive(viewKey: string, active: boolean) {
    hoverActiveByViewKey[viewKey] = active
}

export function getChartHoverActive(viewKey: string): boolean {
    return hoverActiveByViewKey[viewKey] ?? false
}
